import { isEmpty } from 'lodash';
import { useIntl } from 'react-intl';

export type ReminderDateDescriptionData = {
  lastSendDate: string;
  nextSendDate: string;
};

type ReminderDateDescriptionProps = {
  data: ReminderDateDescriptionData;
};

export function ReminderDateDescription({
  data,
}: ReminderDateDescriptionProps) {
  const intl = useIntl();

  if (isEmpty(data.nextSendDate) && isEmpty(data.lastSendDate)) return null;
  const values = {
    last: intl.formatDate(data.lastSendDate, {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    }),
    next: intl.formatDate(data.nextSendDate, {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    }),
  };

  if (data.lastSendDate && data.nextSendDate) {
    return intl.formatMessage(
      {
        id: 'common.reminder-date-description.case-1',
      },
      values
    );
  }
  if (!data.lastSendDate && data.nextSendDate) {
    return intl.formatMessage(
      {
        id: 'common.reminder-date-description.case-2',
      },
      values
    );
  }

  if (data.lastSendDate && !data.nextSendDate) {
    return intl.formatMessage(
      {
        id: 'common.reminder-date-description.case-3',
      },
      values
    );
  }
}
